import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { InteractionZone } from '@components/dnd/base/interaction';
import { useAtom } from '@hooks/useAtom';
import useStores from '@hooks/useStore';
import EndControlsFB from '@library/formBuilder/endControls';
import { FormLabel } from '@mui/joy';
import type { DNDBlock } from '@stratumn/studio-shared';
import { type LucideIcon, Tally2 } from 'lucide-react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

export const OrIcon: LucideIcon = Tally2;

const Or = (dndBlock: DNDBlock) => {
  const dndPath = `${dndBlock.path}:or`;
  const orBlock: DNDBlock[] = dndBlock.props?.or || [];
  const transitionId = useParams()[ParamsList.TransitionId] as string;

  const { atomStore } = useStores();

  const OrBlockAtom = useAtom({
    type: 'Or',
    initialData: {},
    parentId: transitionId,
    sourceId: dndBlock.id,
    parentKind: 'transition'
  });

  // Add reference between parent and child
  useEffect(() => {
    if (!OrBlockAtom) {
      return;
    }
    orBlock.forEach(el => {
      if (el.atomId === dndBlock.atomId) {
        return;
      }

      const childAtom = atomStore.get(el.atomId);

      if (!childAtom) {
        return;
      }

      childAtom.addReferenceToAtom(OrBlockAtom.id);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [OrBlockAtom, dndBlock, atomStore.get, orBlock.forEach]);

  if (!OrBlockAtom) {
    return <></>;
  }

  return (
    <BlockBase
      dndBlock={dndBlock}
      endControls={
        <EndControlsFB
          dataItem={OrBlockAtom}
          dndBlock={dndBlock}
          hasRequired={false}
        />
      }
      hasTitle={false}
      icon={OrIcon}
      isStatement
    >
      <Column>
        <FormLabel sx={{ fontSize: '12px' }}>All conditions</FormLabel>
      </Column>
      <Column $width="100%">
        <InteractionZone dndBlock={orBlock} path={dndPath} />
      </Column>
    </BlockBase>
  );
};

export default observer(Or);
